<div class="swagger-auth-body">
  <div class="error-container">
    <div class="error-icon">🔍</div>

    <h1 class="error-title">Page Not Found</h1>

    <p class="error-message">The page you are looking for doesn't exist or has been moved.</p>

    <div class="error-details">
      <h3>What you can do:</h3>
      <ul>
        <li>Check the URL for typing errors</li>
        <li>Use the navigation menu to find what you're looking for</li>
        <li>Go back to the previous page and try again</li>
        <li>Contact support if you believe this is an error</li>
      </ul>
    </div>

    <div class="action-buttons">
      <button (click)="goToHome()" class="btn btn-primary" type="button">Go to Home</button>
      <button (click)="goBack()" class="btn btn-secondary" type="button">Go Back</button>
    </div>
  </div>

  <div class="footer">
    <p>&copy; {{ getCurrentYear() }} {{ companyName }}. All rights reserved.</p>
    <p>If you continue to experience issues, please contact technical support.</p>
  </div>
</div>
